// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MRStore styles */
.mr-store-container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #FFFFFF;
    min-height: 100vh;
}

.hero-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.hero-text {
    max-width: 50%;
}

.hero-title {
    font-size: 36px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 20px;
}

.hero-title span {
    text-decoration: underline;
}

.hero-button-container {
    display: flex;
    gap: 10px;
}

.mr-store-container .cta-button {
    padding: 14px 28px;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);
    color: white;
    border: none;
    transition: background 0.3s ease;
}

.mr-store-container .cta-button:hover {
    background: linear-gradient(90deg, #cc66ff, #ff66cc, #ff9966, #ffcc99);
}

.hero-image-container {
    transform: translateX(-100px);
}

.hero-image {
    max-width: 400px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.featured-section {
    margin-bottom: 40px;
}

.featured-title {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 10px;
}

.featured-subtext {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
}

.featured-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
}

.featured-item {
    background-color: #f5f5f5;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
}

.featured-item img {
    max-width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 10px;
}

.item-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 5px;
}

.item-price {
    font-size: 16px;
    font-weight: 700;
    color: #d946ef;
    margin-bottom: 5px;
}

.item-description {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

/* Mobile styles */
@media (max-width: 768px) {
    .mr-store-container {
        padding: 15px;
    }

    .hero-section {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 15px;
    }

    .hero-text {
        max-width: 100%;
        margin-bottom: 15px;
    }

    .hero-title {
        font-size: 28px;
        margin-bottom: 15px;
    }

    .hero-button-container {
        justify-content: flex-start;
    }

    .mr-store-container .cta-button {
        padding: 10px 20px;
        font-size: 15px;
        width: 100%;
        max-width: 300px;
    }

    .hero-image-container {
        display: none;
    }

    .featured-section {
        margin-bottom: 30px;
    }

    .featured-title {
        font-size: 24px;
        margin-bottom: 8px;
    }

    .featured-subtext {
        font-size: 14px;
        margin-bottom: 15px;
    }

    .featured-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }

    .featured-item {
        padding: 15px;
    }

    .featured-item img {
        height: 120px;
        margin-bottom: 8px;
    }

    .item-title {
        font-size: 16px;
    }

    .item-price {
        font-size: 14px;
    }

    .item-description {
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .mr-store-container {
        padding: 10px;
    }

    .hero-section {
        margin-bottom: 10px;
    }

    .hero-title {
        font-size: 22px;
        margin-bottom: 10px;
    }

    .mr-store-container .cta-button {
        padding: 8px 16px;
        font-size: 14px;
        max-width: 250px;
    }

    .featured-section {
        margin-bottom: 20px;
    }

    .featured-title {
        font-size: 20px;
        margin-bottom: 6px;
    }

    .featured-subtext {
        font-size: 13px;
        margin-bottom: 10px;
    }

    .featured-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }

    .featured-item {
        padding: 12px;
    }

    .featured-item img {
        height: 100px;
        margin-bottom: 6px;
    }

    .item-title {
        font-size: 14px;
    }

    .item-price {
        font-size: 13px;
    }

    .item-description {
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Css/MRStore.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sEAAsE;IACtE,YAAY;IACZ,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* MRStore styles */\n.mr-store-container {\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n    background-color: #FFFFFF;\n    min-height: 100vh;\n}\n\n.hero-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.hero-text {\n    max-width: 50%;\n}\n\n.hero-title {\n    font-size: 36px;\n    font-weight: 700;\n    color: #1a1a1a;\n    margin-bottom: 20px;\n}\n\n.hero-title span {\n    text-decoration: underline;\n}\n\n.hero-button-container {\n    display: flex;\n    gap: 10px;\n}\n\n.mr-store-container .cta-button {\n    padding: 14px 28px;\n    border-radius: 8px;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    background: linear-gradient(90deg, #ffcc99, #ff9966, #ff66cc, #cc66ff);\n    color: white;\n    border: none;\n    transition: background 0.3s ease;\n}\n\n.mr-store-container .cta-button:hover {\n    background: linear-gradient(90deg, #cc66ff, #ff66cc, #ff9966, #ffcc99);\n}\n\n.hero-image-container {\n    transform: translateX(-100px);\n}\n\n.hero-image {\n    max-width: 400px;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.featured-section {\n    margin-bottom: 40px;\n}\n\n.featured-title {\n    font-size: 32px;\n    font-weight: 700;\n    color: #1a1a1a;\n    margin-bottom: 10px;\n}\n\n.featured-subtext {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 20px;\n}\n\n.featured-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n}\n\n.featured-item {\n    background-color: #f5f5f5;\n    border-radius: 12px;\n    padding: 20px;\n    text-align: center;\n}\n\n.featured-item img {\n    max-width: 100%;\n    height: 150px;\n    object-fit: cover;\n    border-radius: 8px;\n    margin-bottom: 10px;\n}\n\n.item-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1a1a1a;\n    margin-bottom: 5px;\n}\n\n.item-price {\n    font-size: 16px;\n    font-weight: 700;\n    color: #d946ef;\n    margin-bottom: 5px;\n}\n\n.item-description {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 5px;\n}\n\n/* Mobile styles */\n@media (max-width: 768px) {\n    .mr-store-container {\n        padding: 15px;\n    }\n\n    .hero-section {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 15px;\n    }\n\n    .hero-text {\n        max-width: 100%;\n        margin-bottom: 15px;\n    }\n\n    .hero-title {\n        font-size: 28px;\n        margin-bottom: 15px;\n    }\n\n    .hero-button-container {\n        justify-content: flex-start;\n    }\n\n    .mr-store-container .cta-button {\n        padding: 10px 20px;\n        font-size: 15px;\n        width: 100%;\n        max-width: 300px;\n    }\n\n    .hero-image-container {\n        display: none;\n    }\n\n    .featured-section {\n        margin-bottom: 30px;\n    }\n\n    .featured-title {\n        font-size: 24px;\n        margin-bottom: 8px;\n    }\n\n    .featured-subtext {\n        font-size: 14px;\n        margin-bottom: 15px;\n    }\n\n    .featured-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 15px;\n    }\n\n    .featured-item {\n        padding: 15px;\n    }\n\n    .featured-item img {\n        height: 120px;\n        margin-bottom: 8px;\n    }\n\n    .item-title {\n        font-size: 16px;\n    }\n\n    .item-price {\n        font-size: 14px;\n    }\n\n    .item-description {\n        font-size: 13px;\n    }\n}\n\n@media (max-width: 480px) {\n    .mr-store-container {\n        padding: 10px;\n    }\n\n    .hero-section {\n        margin-bottom: 10px;\n    }\n\n    .hero-title {\n        font-size: 22px;\n        margin-bottom: 10px;\n    }\n\n    .mr-store-container .cta-button {\n        padding: 8px 16px;\n        font-size: 14px;\n        max-width: 250px;\n    }\n\n    .featured-section {\n        margin-bottom: 20px;\n    }\n\n    .featured-title {\n        font-size: 20px;\n        margin-bottom: 6px;\n    }\n\n    .featured-subtext {\n        font-size: 13px;\n        margin-bottom: 10px;\n    }\n\n    .featured-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 12px;\n    }\n\n    .featured-item {\n        padding: 12px;\n    }\n\n    .featured-item img {\n        height: 100px;\n        margin-bottom: 6px;\n    }\n\n    .item-title {\n        font-size: 14px;\n    }\n\n    .item-price {\n        font-size: 13px;\n    }\n\n    .item-description {\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
